import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import MainLayout from "./components/layout/MainLayout";
import InstallPrompt from "./components/pwa/InstallPrompt";
import LoginPage from "./pages/LoginPage";
import RecoverPage from "./pages/RecoverPage";
import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import CommessePage from "./pages/CommessePage";
import PipelinePage from "./pages/PipelinePage";
import CalendarPage from "./pages/CalendarPage";
import RelazioniPage from "./pages/RelazioniPage";
import MapPage from "./pages/MapPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";
import BackupPage from "./pages/BackupPage";
import TerritoriesPage from "./pages/TerritoriesPage";
import { Toaster } from "sonner";
import { useAuth } from "./context/AuthContext";
import { Navigate as Nav } from "react-router-dom";

function RoleHome() {
    const { user } = useAuth();
    if (!user) return <Nav to="/login" replace />;
    if (user.role === 'addetto_consegna') return <Nav to="/calendar" replace />;
    if (user.role === 'backoffice') return <Nav to="/clients" replace />;
    return <Nav to="/dashboard" replace />;
}

function RoleGuard({ allow, children }) {
    const { user } = useAuth();
    if (user && !allow.includes(user.role)) return <RoleHome />;
    return children;
}

const NO_ADDETTO = ['admin', 'area_manager', 'commerciale', 'backoffice'];
const CORE = ['admin', 'area_manager', 'commerciale'];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/recover" element={<RecoverPage />} />
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<RoleGuard allow={CORE}><DashboardPage /></RoleGuard>} />
            <Route path="/clients" element={<RoleGuard allow={NO_ADDETTO}><ClientsPage /></RoleGuard>} />
            <Route path="/commesse" element={<RoleGuard allow={NO_ADDETTO}><CommessePage /></RoleGuard>} />
            <Route path="/pipeline" element={<RoleGuard allow={NO_ADDETTO}><PipelinePage /></RoleGuard>} />
            <Route path="/preventivi" element={<RoleGuard allow={NO_ADDETTO}><PipelinePage mode="preventivi" /></RoleGuard>} />
            <Route path="/consegnati" element={<RoleGuard allow={NO_ADDETTO}><PipelinePage mode="consegnati" /></RoleGuard>} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/relazioni" element={<RoleGuard allow={NO_ADDETTO}><RelazioniPage /></RoleGuard>} />
            <Route path="/map" element={<RoleGuard allow={CORE}><MapPage /></RoleGuard>} />
            <Route path="/reports" element={<RoleGuard allow={CORE}><ReportsPage /></RoleGuard>} />
            <Route path="/users" element={<RoleGuard allow={['admin']}><UsersPage /></RoleGuard>} />
            <Route path="/territori" element={<RoleGuard allow={['admin']}><TerritoriesPage /></RoleGuard>} />
            <Route path="/backup" element={<RoleGuard allow={['admin']}><BackupPage /></RoleGuard>} />
          </Route>
          <Route path="/" element={<RoleHome />} />
          <Route path="*" element={<RoleHome />} />
        </Routes>
        <Toaster position="top-right" richColors />
        <InstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
